import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useRecordContext, useResourceContext, CreatePathType } from 'react-admin';
import { Link, LinkProps } from 'shared/mui/Link/Link';

export type ReferenceLinkProps = Omit<LinkProps, 'to'> & {
  type: CreatePathType;
  recordId?: string;
  resource?: string;
};

export const ReferenceLink = ({
  type,
  children,
  target = '_blank',
  underline = 'none',
  recordId = 'id',
  resource,
}: ReferenceLinkProps) => {
  const resourceContext = useResourceContext();
  const record = useRecordContext();
  const { createPathWithQuery } = useCreatePathWithQuery();

  const path = createPathWithQuery({
    resource: resource || resourceContext,
    id: record?.[recordId],
    type: type,
  });

  return (
    <Link href={path} target={target} underline={underline}>
      {children}
    </Link>
  );
};
